import { Component, OnInit, Input } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { PlanAcumulativoService } from '../../../services/plan-acumulativo.service';
import { PlanAcumulativo } from '../../../models/plan-acumulativo';
import { SessionService } from '../../../services/session.service';
import { PlanAcumulativoDetalle } from '../../../models/plan-acumulativo-detalle';
import { ProductoService } from '../../../services/producto.service';

@Component({
	selector: 'plan-acumulativo-modal',
	templateUrl: './plan-acumulativo-modal.component.html',
    styleUrls: ['./plan-acumulativo-modal.component.css'],
    providers: [PlanAcumulativoService,ProductoService]
})
export class PlanAcumulativoModalComponent implements OnInit {
    @Input() plan_id: String;
    public loading = false;
    public plan: PlanAcumulativo;
    public Mod_Inventario: string;
    public detalles:Array<PlanAcumulativoDetalle>;
    
    constructor(
        public bsModalRef: BsModalRef,
        public planAcumulativoService: PlanAcumulativoService,
        private productoService: ProductoService,
        public ss: SessionService,
    ){
        this.plan = new PlanAcumulativo();
        this.Mod_Inventario = this.ss.getData("mod_inventario");
        this.detalles = [];
    }

    ngOnInit(){
        this.getPlanById();
    }

    getPlanById(){
        this.loading = true;
        let qs = '?embed=tipocomprobante,cliente,bodega,detalle?embed=producto';
        this.planAcumulativoService.getById(this.plan_id, qs).subscribe(
            res => {
                this.loading = false;
                this.plan = res.data;
                this.plan.detalle.forEach(item => {
                    let qs = "?embed=unidadmedida";
                    this.productoService.getById(item.producto.id, qs).subscribe(
                        res=>{
                        item.producto = res;
                        },
                        err=>{
                        this.loading = false;
                        }
                    )
				});
            },
            err => {
                this.loading = false;
            }
        );
    }
}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/plan-acumulativo-modal/plan-acumulativo-modal.component.ts